export type AppVersionPlatform = "ios" | "android" | "backoffice";

export const APP_VERSION_PLATFORMS: AppVersionPlatform[] = [
  "ios",
  "android",
  "backoffice",
];

export type AppVersion = {
  _id: string;
  id?: string;
  platform: string;
  version: string;
  apiVersion: string;
  functionalVersion: string;
  isCurrent: boolean;
  releaseNotes: string;
  storeUrl: string;
  isDeleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type AppVersionCreatePayload = {
  platform: AppVersionPlatform;
  version: string;
  apiVersion: string;
  functionalVersion: string;
  releaseNotes?: string;
  storeUrl?: string;
};

export type AppVersionUpdatePayload = {
  platform?: AppVersionPlatform;
  version?: string;
  apiVersion?: string;
  functionalVersion?: string;
  releaseNotes?: string;
  storeUrl?: string;
};
